<template>
  <div>
    <v-dialog v-model="value" max-width="60%" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('target.target_list') }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-container align="center" >
            <v-row align="start" no-gutters>
              <v-col cols="12" v-show="type == 2">
                <v-autocomplete v-model="selectOrderUnit" :items="orderUnits" item-text="name"
                                v-bind:label="$t('location_assign.order_unit')" return-object outlined
                                :dense="true"></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('target.name')" outlined>

                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea v-model="editedItem.description" v-bind:label="$t('target.description')" outlined>

                </v-textarea>
              </v-col>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" @click="cancel" width="120px" class="mr-5">
              {{ $t('common.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn color="primary" @click="createTarget" width="120px" class="mr-5">
              {{ $t('common.done') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
  name: 'target-dialog',

  props: {
    value: Boolean,
    editedItem: Object,
    type: Number
  },

  components: {},

  data: () => ({
    report: '',

    selectOrderUnit: {},
    orderUnits: [],

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      //   v => (v && v.length > 3) || i18n.t('validate.string_invalid')
    ],
  }),

  watch: {},

  async created() {
    if (this.type === 2) {
      await this.getAllOrderUnit();
    }
  },

  methods: {
    cancel() {
      this.$emit('closeDialog', false);
    },

    closeDialog() {
      this.$emit('closeDialog', false);
      this.$emit('updateTarget', this.editedItem);
    },

    async createTarget() {
      if (!this.editedItem.name || this.editedItem.name === '') {
        alert(i18n.t('validate.name_empty'))
      }

      try {
        if (this.type === 0) {
          const requestBody = {
            name: this.editedItem.name,
            description: this.editedItem.description,
            createdBy: this.$getUserID,
            orderUnit: this.editedItem.orderUnit
          }
          const response = await this.$http.post('target/', requestBody);
          if (response.data && response.data.success) {
            this.$fire({
              title: i18n.t('common.success'),
              text: "",
              type: "success"
            }).then(() => {
              this.closeDialog();
            });
          }
        } else if (this.type === 2) {
          const requestBody = {
            name: this.editedItem.name,
            description: this.editedItem.description,
            createdBy: this.$getUserID,
            orderUnit: this.selectOrderUnit
          }
          const response = await this.$http.post('target/', requestBody);
          if (response.data && response.data.success) {
            this.$fire({
              title: i18n.t('common.success'),
              text: "",
              type: "success"
            }).then(() => {
              this.closeDialog();
            });
          }
        } else {
          const response = await this.$http.put('target/' + this.editedItem._id, this.editedItem);
          if (response.data && response.data.success) {
            this.$fire({
              title: i18n.t('common.update_success'),
              text: "",
              type: "success"
            }).then(() => {
              this.closeDialog();
            });
          }
        }

      } catch (e) {
        console.log(e.stack);
      }
    },

    async getAllOrderUnit() {
      this.orderUnits = await this.$getAllOrderUnit();
      if (this.orderUnits.length > 0) {
        this.selectOrderUnit = this.orderUnits[0];
      }
    }
  }
}
</script>